import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    checkboxContainer: 'group relative flex items-center bg-white',
    checkbox:
      'border-main group-hover:border-icon-hover data-[checked]:bg-main flex size-6 min-w-6 cursor-pointer items-center justify-center border transition-colors duration-200 focus:outline-none',
    label: 'cursor-pointer pl-3 font-light transition-colors duration-200',
    helperText: 'mt-1 text-sm font-light',
    icon: 'opacity-0 group-has-[[data-checked]]:opacity-100'
  },
  variants: {
    error: {
      true: {
        checkbox: 'border-error',
        helperText: 'text-error'
      }
    },
    disabled: {
      true: {
        label: 'text-inactive group-hover:text-inactive cursor-not-allowed',
        checkbox:
          'border-icon-secondary-medium data-[checked]:bg-icon-secondary-medium group-hover:border-icon-secondary-medium cursor-not-allowed'
      }
    }
  }
});
